


































































import { Component, Vue } from 'vue-property-decorator'
import { OrderSettings } from '@/api/model/order-settings'
import { OrderType, ReferralType } from '@/api/types'
import { CompanyAPI } from '@/api/backend-client'

@Component
export default class OrdersLegacy extends Vue {
    loading: boolean = false
    orderSettings: OrderSettings = null

    async mounted(): Promise<void> {
        await this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loading = true
        this.orderSettings = await CompanyAPI.getOrderSettings(this.$currentCompany.id)
        this.orderSettings = this.orderSettings ?? OrderSettings.new(this.$currentCompany.id)
        this.loading = false
    }

    isEnabledType(type: OrderType): boolean {
        return this.orderSettings.enabledTypes.some(v => v === type)
    }

    onEnabledTypeChanged(field: OrderType, value: boolean) {
        if (value) {
            if (this.orderSettings.enabledTypes.some(v => v === field)) {
                return
            }

            this.orderSettings.enabledTypes.push(field)

        } else {
            this.orderSettings.enabledTypes = this.orderSettings.enabledTypes.filter(type => type !== field)
        }
    }

    getMappingValue(referralType: ReferralType): OrderType|null {
        return this.orderSettings.typeMapping[referralType]
    }

    updateMapping(referralType: ReferralType, orderType: OrderType): void {
        if (!orderType) {
            delete this.orderSettings.typeMapping[referralType]
            this.$forceUpdate()
        }

        if (this.orderSettings.enabledTypes.includes(orderType)) {
            this.$set(this.orderSettings.typeMapping, referralType, orderType)
        }
    }

    async save(): Promise<void> {
        this.loading = true
        const orderSettings = await CompanyAPI.updateOrderSettings(this.$currentCompany.id, this.orderSettings)
        this.$set(this.$currentCompany, 'orderSettings', orderSettings)
        this.$notify({
            group: 'information',
            type: 'success',
            title: this.$t('company_settings.orders.success.title').toString(),
            text: this.$t('company_settings.orders.success.message').toString(),
        })
        this.loading = false
    }

    get internalReferralTypes(): Array<{ label: string, value: string }> {
        return this.$currentCompany.handledInternalReferralTypes
            .map((type: string) => ({
                label: this.$t(`referral.type.${type}`) as string,
                value: type,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
    }

    get enabledTypes(): Array<{ label: string, value: string }> {
        return this.orderSettings.enabledTypes.map(orderType => {
            return {
                label: this.$t(`order.type.${orderType}`).toString(),
                value: `${orderType}`,
            }
        })
    }

    get yesNoOptions(): Array<{ label: string, value: boolean }> {
        return [
            { label: this.$t('yes').toString(), value: true },
            { label: this.$t('no').toString(), value: false },
        ]
    }
}
